import type { MouseEvent as ReactMouseEvent } from 'react';

import type {
  LayoutPoint,
  ViewerPosition,
} from '../contracts/models';

export interface PolygonEditOverlayProps {
  points: readonly LayoutPoint[];
  draggingNodeIndex: number | null;
  snapPosition?: ViewerPosition | null;
  onNodeMouseDown(
    nodeIndex: number,
    event: ReactMouseEvent<SVGCircleElement>,
  ): void;
}

export const PolygonEditOverlay = ({
  points,
  draggingNodeIndex,
  snapPosition,
  onNodeMouseDown,
}: PolygonEditOverlayProps) => (
  <g className="iv-polygon-edit-overlay">
    {points.map(([x, y], index) => {
      const isDragging = draggingNodeIndex === index;
      return (
        <g
          key={`${x}:${y}:${index}`}
          className="iv-polygon-edit-node"
          style={{ pointerEvents: 'auto' }}
        >
          <circle
            cx={x}
            cy={y}
            r="10"
            fill="transparent"
            className="iv-polygon-edit-node-target"
            style={{ cursor: 'move' }}
            onMouseDown={(event) =>
              onNodeMouseDown(index, event)
            }
          />
          <circle
            cx={x}
            cy={y}
            r="6"
            fill={isDragging ? '#1d4ed8' : '#3b82f6'}
            stroke="white"
            strokeWidth="2"
            className="iv-polygon-edit-node-glyph"
            style={{
              cursor: 'move',
              opacity: isDragging ? 0.8 : 1,
              transform: isDragging ? 'scale(1.3)' : 'scale(1)',
              transition: isDragging
                ? 'none'
                : 'transform 0.1s ease',
              pointerEvents: 'none',
            }}
          />
          <text
            x={x}
            y={y}
            textAnchor="middle"
            dominantBaseline="middle"
            fill="white"
            fontSize="8"
            fontWeight="bold"
            style={{ pointerEvents: 'none' }}
          >
            {index + 1}
          </text>
        </g>
      );
    })}
    {snapPosition ? (
      <circle
        cx={snapPosition.x}
        cy={snapPosition.y}
        r="8"
        fill="none"
        stroke="#f59e0b"
        strokeWidth="3"
        strokeDasharray="4,4"
        className="iv-polygon-snap-indicator"
        style={{ pointerEvents: 'none' }}
      />
    ) : null}
  </g>
);
